


































































































































import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";

// Vue components
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import GlobalStatusInstallationChip from "@/views/App/Components/chips/GlobalStatusInstallationChip.vue";
import DeviceModelChip from "@/views/App/Components/chips/DeviceModelChip.vue";
import BranchFilter from "@/components/TableHeaderFilters/BranchFilter.vue";
import DateRangeFilter from "@/components/TableHeaderFilters/DateRangeFilter.vue";
import MachineModelFilter from "@/components/TableHeaderFilters/MachineModelFilter.vue";
import TagsFilter from "@/components/TableHeaderFilters/TagsFilter.vue";
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";
import ServiceModeStatusFilter from "@/components/TableHeaderFilters/ServiceModeStatusFilter.vue";
import MaintenanceStatusFilter from "@/components/TableHeaderFilters/MaintenanceStatusFilter.vue";
import MaintenanceStatusChip from "@/views/App/ServiceAndUpdates/DeviceStatus/MaintenanceStatusChip.vue";
import InstallationResumeDialog from "@/components/InstallationResumeDialog.vue";
import LocaleDateTimeTooltip from "@/components/LocaleDateTimeTooltip.vue";

import { dataTableItemsPerPage } from "@/utility/Constants";
import { serviceModeStatusEnumLabel, ServiceModeStatusEnum } from "@/model/data/serviceMode/ServiceModeStatusEnum";
import { InstallationStatus } from "@/model/data/status/InstallationStatus";

export default Vue.extend({
    components: {
        TableFiltersRow,
        GlobalStatusInstallationChip,
        DeviceModelChip,
        ColumnVisibilityFilter,
        MaintenanceStatusChip,
        InstallationResumeDialog,
        LocaleDateTimeTooltip,
    },
    props: {
        loading: { required: true, type: Boolean },
        paginatedTotalItems: Number,
        installations: { required: true, type: Array },
        reqData: Object,
    },
    data() {
        return {
            moment,
            prevIcon: "fas fa-chevron-left",
            nextIcon: "fas fa-chevron-right",
            ServiceModeStatusEnum,
            dataTableItemsPerPage,
            firstTime: true,
            options: {},
            ignoreOptionsChanges: false,
            availableHeaders: [],
            selectedInstallation: null,
            showDialog: false,
            initialAvailableHeaders: [
                {
                    enabled: true,
                    text: this.$t("common.maintenance"),
                    value: "maintenance",
                    sortable: false,
                },
                {
                    enabled: false,
                    text: this.$t("common.serviceMode"),
                    value: "serviceModeStatus",
                },
                {
                    enabled: true,
                    text: this.$t("common.name"),
                    value: "name",
                },
                {
                    enabled: true,
                    text: this.$t("common.nextMaintenance"),
                    value: "nextMaintenance",
                    sortable: true,
                },
                {
                    enabled: false,
                    text: this.$t("common.tags"),
                    value: "tags",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("common.branch"),
                    value: "branch.name",
                },
                {
                    enabled: false,
                    text: this.$t("common.agent_ip"),
                    value: "agentInfo.ip",
                },
                {
                    enabled: false,
                    text: this.$t("device_status.pc_name"),
                    value: "connectedPc",
                },
                {
                    enabled: true,
                    text: this.$t("common.last_update"),
                    value: "lastMessage",
                },
                {
                    enabled: false,
                    text: this.$t("common.last_agent_message"),
                    value: "agentInfo.lastMessage",
                    sortable: true,
                },
                {
                    enabled: true,
                    text: this.$t("common.device/s"),
                    value: "machines",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("common.actions"),
                    value: "actions",
                    sortable: false,
                    width: "150px",
                },
            ],
            filters: [
                {
                    headerValue: "serviceModeStatus",
                    filterKey: "serviceModeStatusFilter",
                    component: ServiceModeStatusFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "maintenance",
                    filterKey: "maintenanceStatusList",
                    component: MaintenanceStatusFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "branch.name",
                    filterKey: "branchNames",
                    component: BranchFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "tags",
                    filterKey: "tagValues",
                    component: TagsFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "lastMessage",
                    filterKey: "installationLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_installation_message") }),
                },
                {
                    headerValue: "agentInfo.lastMessage",
                    filterKey: "agentLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_agent_message") }),
                },
                {
                    headerValue: "machines",
                    filterKey: "machineModels",
                    component: MachineModelFilter,
                    currentSelections: [],
                },
            ],
            completeFormatThreshold: null,
            monthYearFormatThreshold: null,
        };
    },
    watch: {
        options: {
            handler(newOptions, oldOptions) {
                if (oldOptions != null) {
                    if (newOptions.page < oldOptions.page) this.prevIcon = "fas fa-circle-notch fa-spin";
                    if (newOptions.page > oldOptions.page) this.nextIcon = "fas fa-circle-notch fa-spin";
                }
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },
        installations: {
            handler() {
                if (this.firstTime && this.$route.query.options != null && this.$route.query.options != undefined) {
                    let queryOptions = JSON.parse(atob(this.$route.query.options));
                    this.$emit("options-changed", queryOptions);
                    this.options = queryOptions;
                }
                if (
                    this.firstTime &&
                    this.installations.find((i) => i.name == this.$route.query.installation) != undefined &&
                    this.installations.find((i) => i.name == this.$route.query.installation) != null
                ) {
                    if (this.$route.query.showdialog) this.showDialog = this.$route.query.showdialog == "true";
                    if (this.$route.query.installation) this.selectedInstallation = this.installations.find((i) => i.name == this.$route.query.installation);

                    this.firstTime = false;
                }
            },
            deep: true,
        },
        loading(newVal) {
            if (!newVal) {
                this.prevIcon = "fas fa-chevron-left";
                this.nextIcon = "fas fa-chevron-right";
            }
        },
    },
    computed: {
        ...mapGetters(["longDateFormat"]),
    },
    methods: {
        serviceModeStatusEnumLabel,
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
                console.debug("backToTheFirst, this.options: ", this.options);
            }
        },
        handleClick(value: InstallationStatus) {
            if (window.getSelection().toString()) {
                return;
            }
            this.showDialog = true;
            this.selectedInstallation = value;
        },
        newTabDialog(value: any) {
            if (this.reqData) {
                let routeData = this.$router.resolve({
                    name: this.$route.name,
                    query: { showdialog: true, installation: value.name, options: btoa(JSON.stringify(this.options)), reqData: btoa(JSON.stringify(this.reqData)) },
                });
                window.open(routeData.href, "_blank");
            } else {
                let routeData = this.$router.resolve({
                    name: this.$route.name,
                    query: { showdialog: true, installation: value.name, options: btoa(JSON.stringify(this.options)) },
                });
                window.open(routeData.href, "_blank");
            }
        },
        getLabelForForecastedDate(forecastedLabel) {
            let forecastedDate = moment(forecastedLabel);
            if (forecastedDate < this.completeFormatThreshold) return forecastedDate.format(this.longDateFormat(false, true, true, true));
            if (forecastedDate < this.monthYearFormatThreshold) return forecastedDate.format(this.longDateFormat(false, true, true, true, true, false, true));
            return this.$t("common.notDueSoon");
        },
    },
    mounted() {
        let currentDate = new Date();
        this.completeFormatThreshold = new Date(currentDate.setMonth(currentDate.getMonth() + 2));
        this.monthYearFormatThreshold = new Date(currentDate.setMonth(currentDate.getMonth() + 12));
    },
});
